// oxlint-disable react/only-export-components -- este arquivo e o mapa de
// rotas: exporta o router e declara os componentes lazy que ele referencia.
import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router'
import { AppShell } from './components/layout/AppShell'
import { RotaProtegida } from './components/layout/RotaProtegida'
import { SkeletonLista } from './components/feedback/Skeleton'

const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })))
const CategoriasPage = lazy(() =>
  import('./pages/CategoriasPage').then((m) => ({ default: m.CategoriasPage })),
)
const EmpresasPage = lazy(() =>
  import('./pages/EmpresasPage').then((m) => ({ default: m.EmpresasPage })),
)
const EmpresaPage = lazy(() =>
  import('./pages/EmpresaPage').then((m) => ({ default: m.EmpresaPage })),
)
const BuscarPage = lazy(() =>
  import('./pages/BuscarPage').then((m) => ({ default: m.BuscarPage })),
)
const ExcursoesPage = lazy(() => import('./pages/ExcursoesPage').then((m) => ({ default: m.ExcursoesPage })))
const MaisPage = lazy(() => import('./pages/MaisPage').then((m) => ({ default: m.MaisPage })))
const ContatoPage = lazy(() =>
  import('./pages/ContatoPage').then((m) => ({ default: m.ContatoPage })),
)
const TextoPage = lazy(() =>
  import('./pages/ConteudoPages').then((m) => ({ default: m.TextoPage })),
)
const NoticiasPage = lazy(() =>
  import('./pages/ConteudoPages').then((m) => ({ default: m.NoticiasPage })),
)
const NoticiaPage = lazy(() =>
  import('./pages/ConteudoPages').then((m) => ({ default: m.NoticiaPage })),
)
const VideosPage = lazy(() =>
  import('./pages/ConteudoPages').then((m) => ({ default: m.VideosPage })),
)
const EntrarPage = lazy(() =>
  import('./pages/empresa/EntrarPage').then((m) => ({ default: m.EntrarPage })),
)
const RecuperarSenhaPage = lazy(() =>
  import('./pages/empresa/RecuperarSenhaPage').then((m) => ({ default: m.RecuperarSenhaPage })),
)
const PrimeiroAcessoPage = lazy(() =>
  import('./pages/empresa/PrimeiroAcessoPage').then((m) => ({ default: m.PrimeiroAcessoPage })),
)
const CadastroEmpresaPage = lazy(() =>
  import('./pages/empresa/CadastroEmpresaPage').then((m) => ({ default: m.CadastroEmpresaPage })),
)
const MinhaEmpresaPage = lazy(() =>
  import('./pages/empresa/MinhaEmpresaPage').then((m) => ({ default: m.MinhaEmpresaPage })),
)
const EditarDadosPage = lazy(() =>
  import('./pages/empresa/EditarDadosPage').then((m) => ({ default: m.EditarDadosPage })),
)
const EditarFotosPage = lazy(() =>
  import('./pages/empresa/EditarFotosPage').then((m) => ({ default: m.EditarFotosPage })),
)
const ContaPage = lazy(() =>
  import('./pages/empresa/ContaPage').then((m) => ({ default: m.ContaPage })),
)
const ExcluirContaPage = lazy(() =>
  import('./pages/empresa/ExcluirContaPage').then((m) => ({ default: m.ExcluirContaPage })),
)
const PoliticaPrivacidadePage = lazy(() =>
  import('./pages/LegalPages').then((m) => ({ default: m.PoliticaPrivacidadePage })),
)
const ComoExcluirContaPage = lazy(() =>
  import('./pages/LegalPages').then((m) => ({ default: m.ComoExcluirContaPage })),
)
// Painel administrativo: fica fora do AppShell e em chunk próprio, para não
// pesar no app de quem só navega.
const AdminLayout = lazy(() => import('./admin/AdminPages').then((m) => ({ default: m.AdminLayout })))
const AdminInicio = lazy(() => import('./admin/AdminPages').then((m) => ({ default: m.AdminInicio })))
const AdminLista = lazy(() => import('./admin/AdminPages').then((m) => ({ default: m.AdminLista })))
const AdminFormulario = lazy(() =>
  import('./admin/AdminPages').then((m) => ({ default: m.AdminFormulario })),
)
const NaoEncontradaPage = lazy(() =>
  import('./pages/ConteudoPages').then((m) => ({ default: m.NaoEncontradaPage })),
)

function Layout() {
  return (
    <AppShell>
      <Suspense
        fallback={
          <div className="px-4 pt-4">
            <SkeletonLista quantidade={4} />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </AppShell>
  )
}

export const router = createBrowserRouter([
  {
    path: '/admin',
    element: (
      <Suspense fallback={null}>
        <AdminLayout />
      </Suspense>
    ),
    children: [
      { index: true, element: <AdminInicio /> },
      { path: ':recurso', element: <AdminLista /> },
      { path: ':recurso/:id', element: <AdminFormulario /> },
    ],
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'categorias', element: <CategoriasPage /> },
      { path: 'empresas', element: <EmpresasPage /> },
      // Rota canonica por id. O slug e enfeite e nunca resolve sozinho:
      // url_amigavel esta vazia ou duplicada em boa parte dos registros.
      { path: 'empresa/:id', element: <EmpresaPage /> },
      { path: 'buscar', element: <BuscarPage /> },
      { path: 'excursoes', element: <ExcursoesPage /> },
      { path: 'mais', element: <MaisPage /> },
      { path: 'contato', element: <ContatoPage /> },
      { path: 'pagina/:id', element: <TextoPage /> },
      { path: 'noticias', element: <NoticiasPage /> },
      { path: 'noticias/:id', element: <NoticiaPage /> },
      { path: 'videos', element: <VideosPage /> },
      // Endereços públicos informados nas lojas (Apple e Google).
      { path: 'politica-de-privacidade', element: <PoliticaPrivacidadePage /> },
      { path: 'excluir-conta', element: <ComoExcluirContaPage /> },

      // --- Área da empresa ---
      { path: 'entrar', element: <EntrarPage /> },
      { path: 'recuperar-senha', element: <RecuperarSenhaPage /> },
      { path: 'primeiro-acesso', element: <PrimeiroAcessoPage /> },
      { path: 'cadastro-empresa', element: <CadastroEmpresaPage /> },
      {
        path: 'minha-empresa',
        element: <RotaProtegida />,
        children: [
          { index: true, element: <MinhaEmpresaPage /> },
          { path: 'dados', element: <EditarDadosPage /> },
          { path: 'fotos', element: <EditarFotosPage /> },
          { path: 'conta', element: <ContaPage /> },
          { path: 'excluir', element: <ExcluirContaPage /> },
        ],
      },
      { path: '*', element: <NaoEncontradaPage /> },
    ],
  },
])
